export default __webpack_public_path__ + "static/media/kvitanciya1.dcd57a39.xls";